import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from '../../core/guards';
import { StoreStocksComponent } from './store-stocks/store-stocks.component';

const routes: Routes = [
  {
    path: '',
    component: StoreStocksComponent,
    canActivate: [ authGuard ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StorestocksRoutingModule { }
